export default "__VITE_ASSET__CAzPE$Gg__"